import {Injectable} from '@angular/core';
import {HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {DictModel} from '../dictionary/dict.model';

@Injectable()
export class MockDictService {

  getSkills(): any {
    let response: DictModel[];
    response = [
      {
        id: 1,
        description: 'Java',
        descriptionEng: 'Java'
      },
      {
        id: 2,
        description: 'C#',
        descriptionEng: 'C#'
      },
      {
        id: 3,
        description: 'Angular JS',
        descriptionEng: 'Angular JS'
      },
      {
        id: 4,
        description: 'Angular 4',
        descriptionEng: 'Angular 4'
      }
    ];
    return new Observable(resp => {
      resp.next(new HttpResponse({
        status: 200,
        body: response
      }));
      resp.complete();
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/mock/mock-dict.service.ts